import React, { Component } from 'react';
import { openCardFree } from './service'
import { getCampusPay } from '../cardBinding/service'
import { Toast, Form, Input, Button, Space, SpinLoading,Image } from 'antd-mobile'
import { EyeOutline, EyeInvisibleOutline } from 'antd-mobile-icons'
import {debounce} from '../../utils/util'
import './index.scss';
import wx from 'weixin-js-sdk';

var browser = {
  versions: function () {
      var u = navigator.userAgent;
      return {
          ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
          android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 || u.indexOf('Linux') > -1, //android终端
      };
  }(),
}

class CardPasswordFreePay extends Component {
  constructor(props) {
    super(props)
    this.state = {
      projectId: null,
      userId: null,
      payWay: null,
      telPhone: null,
      loginCode: null,
      accountId: null,
      isLoading: false,
      campusAccount: null,
      campusPassword: null,
      campusName: null,
      CampusPayInformation: {},
      iconEye: <img src={require('../../assets/icon-eye-close.png')} />,
      closeEye: true,
      phoneSystem: null,
    }
    this.onSubmit = debounce(this.onSubmit, 1000)

  }
  componentDidMount() {
    document.title="开通一卡通免密支付"
    let search = window.location.search.slice(1)
    let params = search.split('&')
    var theRequest = new Object()
    for (let i = 0; i < params.length; i++) { 
      theRequest[params[i].split("=")[0]] = decodeURIComponent(params[i].substring(params[i].indexOf('=') + 1));
    }
    this.setState({
      projectId: theRequest.projectId,
      telPhone: theRequest.telPhone,
      userId: theRequest.userId,
      loginCode: theRequest.loginCode,
      accountId: theRequest.accountId,
      phoneSystem: theRequest.phoneSystem,
    }, () => {
      this.getCampusPayVerify()
    })
  }
  getCampusPayVerify = () => {
    let params = {
        projectId: this.state.projectId,
        userId: this.state.userId,
        loginCode: this.state.loginCode,
        accountId: this.state.accountId,
    }
    if (this.state.phoneSystem) {
      params.phoneSystem = this.state.phoneSystem;
    }
    getCampusPay(params).then(res => {
        if (res.errorCode == 0) {
          this.setState({
            CampusPayInformation: res.data,
            isLoading: false
          })
        } else {
            Toast.show({
                content: res.errorMessage,
                position: 'bottom',
            })
            this.setState({
                isLoading: false
            })
        }
    })
}

  // 控制密码框显隐
  changeEyeClose = () => {
    this.setState({
      closeEye: false,
      iconEye: <img src={require('../../assets/icon-eye-open.png')} />
    })
  }
  changeEyeOpen = () => {
    this.setState({
      closeEye: true,
      iconEye: <img src={require('../../assets/icon-eye-close.png')} />
    })
  }

  // 返回app
  
  onBackApp = () => {
    
    var userAgent = navigator.userAgent;
    const OpenHarmony = /(OpenHarmony).*?/.test(userAgent);
    const ua = userAgent.toLowerCase();
    const isWeChat = /micromessenger/.test(ua);
    if (isWeChat) {
      // 在微信中，尝试使用小程序接口
      wx.miniProgram.getEnv((res) => {
        if (res.miniprogram) {
          wx.miniProgram.navigateBack({
            delta: 1
          })
        }
    })
    } 
    if (browser.versions.android || OpenHarmony) {
      window.android.onCampusPayExit();
      return;
    }
    if (browser.versions.ios) {
      window.webkit.messageHandlers.onCampusPayExit.postMessage('');
      return;
    }
  }

  onClick = () => {
    if (!this.getValid()) {
      Toast.show({
        content: '请完善必填信息，且输入内容不超过40字',
        position: 'bottom',
      });
    } else {
      this.onSubmit();
    }
  }

  /**
    * 开通
    */
  onSubmit = () => {
    this.setState({
      isLoading: true
    })
    let { telPhone, projectId, userId, campusPassword, campusAccount, loginCode, accountId, phoneSystem ,campusName} = this.state
    let params = {
      telPhone,
      projectId,
      campusPassword,
      campusAccount,
      userId,
      loginCode,
      accountId,
      campusName
    }
    if (phoneSystem) {
      params.phoneSystem = phoneSystem;
    }
    openCardFree(params).then(res => {
      if (res.errorCode == 0) {
        this.setState({
          isLoading: false,
          campusAccount: null,
          campusPassword: null,
          campusName: null,
        })
        Toast.show({
          content: '开通成功！',
          position: 'bottom',
        })
        setTimeout(() => {
          this.onBackApp()
        }, 100);
      } else {
        this.setState({
          isLoading: false,
          campusAccount: null,
          campusPassword: null,
          campusName: null,
        })
        Toast.show({
          content: res.errorMessage,
          position: 'bottom',
        })
      }
    })
  }

  getValid = () => {
    const { CampusPayInformation, campusAccount, campusPassword, campusName } = this.state;

    const validations = [];

    if (CampusPayInformation.verifyIdName) {
      validations.push(campusAccount !== null && campusAccount !== '' && campusAccount?.length <= 40);
    }
    if (CampusPayInformation.cvvName) {
      validations.push(campusPassword !== null && campusPassword !== '' && campusPassword?.length <= 40);
    }
    if (CampusPayInformation.cvvNameTwo) {
      validations.push(campusName !== null && campusName !== '' && campusName?.length <= 40);
    }

    return validations.length > 0 && validations.every(valid => valid);
  };

  render() {
    const { campusPassword, campusAccount, campusName, CampusPayInformation, iconEye, closeEye } = this.state
    return (
      <>
        {!this.state.isLoading ? <div className="card-password-free-pay-page">
          <Form
            // layout='horizontal'
            // key={userInformation.balance}
            // onFinish={this.onSubmit}
            footer={
              <Button
                block
                class='open-btn'
                color='primary'
                type='submit'
                size='large'
                onClick={this.onClick}
                // disabled={!this.getValid()}
                style={this.getValid() ? { background: 'linear-gradient( 270deg, #5BA1FD 0%, #6FBDFF 100%)' } : { backgroundColor: '#BBBBBB' }}
              >
                立即开通
              </Button>
            }
          >
            {CampusPayInformation.verifyIdName && 
              <Form.Item label={CampusPayInformation.verifyIdName}
                name='campusAccount'
                className="user-text"
                rules={[
                  {
                    pattern: /^.{0,40}$/,
                    message: "最多输入40字",
                  },
                ]}>
                <Input
                  value={campusAccount}
                  onBlur={(val) => {
                    this.setState({
                      campusAccount: val.target.value
                    })
                  }}
                  placeholder={CampusPayInformation.verifyIdPrompt}
                  clearable
                />
              </Form.Item>}
            {CampusPayInformation.cvvName && 
              <Form.Item label={CampusPayInformation.cvvName}
                name='campusPassword'
                className="user-text"
                rules={[
                  {
                    pattern: /^.{0,40}$/,
                    message: "最多输入40字",
                  },
                ]}>
              {/* {closeEye ? <div><Input
                type="password"
                value={campusPassword}
                onChange={(val) => {
                  this.setState({
                    campusPassword: val
                  })
                }}
                placeholder={CampusPayInformation.cvvPrompt}
                clearable
              />
                <span className='icon-eye' onClick={()=>this.changeEyeClose()}>{iconEye}</span>
              </div>
                :
                <div> */}
                <Input
                  value={campusPassword}
                  onBlur={(val) => {
                    this.setState({
                      campusPassword: val.target.value
                    })
                  }}
                  type='password' 
                  placeholder={CampusPayInformation.cvvPrompt}
                  clearable
                />
                {/* <span className='icon-eye' onClick={()=>this.changeEyeOpen()}>{iconEye}</span>
              </div>} */}
            </Form.Item>}
            {CampusPayInformation.cvvNameTwo && 
              <Form.Item label={CampusPayInformation.cvvNameTwo}
                name='campusName'
                className="user-text"
                rules={[
                  {
                    pattern: /^.{0,40}$/,
                    message: "最多输入40字",
                  },
                ]}>
              <Input
                value={campusName}
                onBlur={(val) => {
                  this.setState({
                    campusName: val.target.value
                  })
                }}
                placeholder={CampusPayInformation.cvvPromptTwo}
                clearable
              />
            </Form.Item>}
            <Form.Header>
              <div className="card-recharge-footer">
                <span className="footer-babel">温馨提示：</span>
                <p>{CampusPayInformation.remark}</p>
              </div>
            </Form.Header>
            <span></span>
          </Form>
        </div>
          :
          <div className="pay-page-loading">
            <Space direction='horizontal' wrap block style={{ '--gap': '16px' }}>
              <SpinLoading color='primary' />
            </Space>
          </div>

        }
      </>
    );
  }

}

export default CardPasswordFreePay;